<template>
    <div class="widget-wrapper border border-ui-lines p-3 lg:p-4 rounded-md main-bg-light">
        <div class="flex items-center gap-3 xl:gap-4">
            <span class="flex-shrink-0">
                <component
                    :is="templateIcon"
                    class="text-primary w-10"
                />
            </span>
            <div
                class="flex flex-grow"
            >
                <p class="main-text-color">
                    {{ $t(widget.DefaultWidgetTitle || '') }}
                </p>
            </div>
            <div
                v-if="!!widgetHelpInfo"
                class="flex text-primary hover:text-primary-actions--focus cursor-help break-keep"
                @click="onLearnMore"
            >
                <span class="mx-1">
                    {{ $t('widget.learnMore') }}
                </span>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { WidgetListExtended } from '@/types/dashboard'
import { computed } from 'vue'
import { getHelpByWidgetsTemplateID } from '@/composables/globalData/useTemplatesDictionaryData'
import { templateIcons } from '@/enum/widgetDataTypes'
import get from 'lodash/get'

const props = defineProps<{
    widget: WidgetListExtended
}>()
const emit = defineEmits<{
    (e: 'learnMore', widget: WidgetListExtended): void
}>()

const widgetHelpInfo = computed(() => {
    const templateID = props.widget.WidgetTemplateID
    return getHelpByWidgetsTemplateID(templateID)
})
const templateIcon = computed(() => {
    const dataTypeID = get(props.widget, 'WidgetLayout.DataTypeID', 0) as keyof typeof templateIcons
    if (!dataTypeID) {
        return 'IconTemplateDefault'
    }
    return templateIcons[dataTypeID] || templateIcons.Default
})

function onLearnMore () {
    emit('learnMore', props.widget)
}

</script>
